export const FRONTEND_URL = {
  home: "/dashboard",
  document: "/document",
  documentDetail: "/document/:fileId",
  account: "/account",
  auth: "/auth",
};
